import AddressCompanyNameCell from './container';

export default AddressCompanyNameCell;
